// Todo: Copy Paste from other template :D Please fix someday
export const exoClickTemplateDataId = "exoclick-before-pagination-sol"
export const exoClickBeforePaginationHtmlMobile = `<section id="page-top-sol" class="page-stripe page-stripe-page-top-sol page-stripe-content-exoclick-mobile no-solads-label extra-top-spacing" data-exoclick-id="${exoClickTemplateDataId}">
    <div class="container">
        <div class="row-page-actions-sol base-row row">
            <div class="sol-content uncensored-banner relative text-left content-width-320">
                <div class="sol-advert-mark">
                    <span class="sol-label"><a href="https://www.exoclick.com/de/" target="_blank" rel="nofollow">ExoClick</a></span>
                    <small class="sol-text-label">Anzeige</small>
                </div>

                <div class="sol-frame sol-type-display uncensored-banner-container" >
                    <script async="async" type="application/javascript" src="https://a.magsrv.com/ad-provider.js"></script>
                    <ins class="eas6a97888e" data-zoneid="5040788"></ins>
                    <span class="separator"> </span>
                    <div style="position: relative; right: 0px; bottom: 0px;"><div style="position:absolute; font-weight:bold; opacity:0.6; bottom:0px; right:0px; background-color:black; color:white; padding-bottom:0.2em; padding-left:0.5em; padding-right:0.5em; font-size:8px;"><a style="color:white!important; text-decoration:none!important;" target="_blank" rel="nofollow" href="https://www.exoclick.com/de/">ExoClick</a></div></div>
                    <script>(AdProvider = window.AdProvider || []).push({"serve": {}});</script>
                </div>

                <div class="text-center banner-free-container ausblenden">
                    <button class="btn btn-link ad-free-link" role="link" type="button" data-toggle="modal" data-target="#banner-free-modal">
                        <span>Diese Werbung ausblenden</span>
                        <span class="icon icon-12 inline icon-remove-banner">
                                <svg viewBox="0 0 20 20">
                                    <polygon points="2,16.7 8.7,10 8.7,10 2,3.3 3.3,2 10,8.7 16.7,2 18,3.3 11.3,10 11.3,10 18,16.7 16.7,18 10,11.3 3.3,18"/>
                                </svg>
                            </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>`

export const exoClickBeforePaginationHtmlPc =
    () => `<div class="col-xs-12 page-stripe-exoclick-pagination" data-exoclick-id="${exoClickTemplateDataId}">
    <div class="item clearfix text-left">
        <div class="sol-content uncensored-banner relative col-xs-12 content-width-240">
            <div class="sol-advert-mark">
                <span class="sol-label">
                    <a href="https://www.exoclick.com/de/" target="_blank" rel="nofollow">ExoClick</a>
                </span>
                <small class="sol-text-label">Anzeige</small>
            </div>
            <div class="sol-frame sol-type-display uncensored-banner-container" data-columns="2">
                <script async type="application/javascript" src="https://a.magsrv.com/ad-provider.js"></script>
                <ins class="eas6a97888e" data-zoneid="5040790"></ins>
                <span class="separator">&nbsp;</span>
                <script>(AdProvider = window.AdProvider || []).push({ "serve": {} }); </script>
            </div>
        </div>
        <div class="text-center banner-free-container nichtZeigen"><button class="btn btn-link ad-free-link" role="link"
                type="button" data-toggle="modal" data-target="#banner-free-modal">
                <span class="label">Diese Werbung nicht mehr anzeigen?</span>
            </button>
        </div>
    </div>
</div>`

export const exoClickBottomPc = `<section id="exoclick-bottom" class="page-stripe page-stripe-content-solads page-stripe-content-exoclick white no-top-spacing no-bottom-spacing exoclick-bottom">
    <div class="container">
        <div class="row">
                <div class="row service-sol">
                    <div class="sol-content uncensored-banner col-xs-12">
                        <div class="sol-advert-mark">
                            <span class="sol-label"><a href="https://www.exoclick.com/de/" target="_blank" rel="nofollow">ExoClick</a></span>
                            <small class="sol-text-label">Anzeige</small>
                        </div>

                        <div class="sol-frame sol-type-display uncensored-banner-container" >
                            <script async="async" type="application/javascript" src="https://a.magsrv.com/ad-provider.js"></script>
                            <ins class="eas6a97888e" data-zoneid="5040790"></ins>
                            <span class="separator"> </span>
                            <script>(AdProvider = window.AdProvider || []).push({"serve": {}});</script>
                        </div>
                        <div class="text-center banner-free-container nichtZeigen">
                            <button class="btn btn-link ad-free-link" role="link" type="button" data-toggle="modal" data-target="#banner-free-modal">
                                <span class="label">Diese Werbung nicht mehr anzeigen?</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</section>`
